"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Contact;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.promise.js");
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _LoadingButton = _interopRequireDefault(require("@mui/lab/LoadingButton"));
var _formik = require("formik");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _ContentCopy = _interopRequireDefault(require("@mui/icons-material/ContentCopy"));
var _Send = _interopRequireDefault(require("@mui/icons-material/Send"));
var _analytics = require("firebase/analytics");
var _CopyToClipboard = _interopRequireDefault(require("./CopyToClipboard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Contact(props) {
  const {
    t,
    navigate,
    globalActions,
    signInCheckResult,
    sendEmail,
    analytics
  } = props;
  const [success, setsuccess] = _react.default.useState(false);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    component: "span"
  }, t('contact.title')), !success && /*#__PURE__*/_react.default.createElement(ContactForm, {
    t: t,
    analytics: analytics,
    setsuccess: setsuccess,
    globalActions: globalActions,
    sendEmail: sendEmail,
    signInCheckResult: signInCheckResult
  }), success && /*#__PURE__*/_react.default.createElement(_Paper.default, {
    sx: {
      width: '100%',
      p: 3,
      maxWidth: 800,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 1,
      gap: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    component: "span"
  }, t('contact.success')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    onClick: () => {
      navigate(-1);
    }
  }, t('back'))));
}
function ContactForm(props) {
  const [sending, setsending] = _react.default.useState(false);
  const {
    setsuccess,
    t,
    globalActions,
    sendEmail,
    signInCheckResult,
    analytics
  } = props;
  const [emailStatus, setemailStatus] = _react.default.useState('initial');
  const formik = (0, _formik.useFormik)({
    initialValues: {
      email: '',
      nameAndCompany: '',
      message: ''
    },
    validate: values => {
      const errors = {};
      if (!values.email) {
        errors.email = t('validations.required');
      }
      if (!values.message) {
        errors.message = t('validations.required');
      }
      return errors;
    },
    async onSubmit(values, _ref) {
      let {
        setSubmitting
      } = _ref;
      try {
        setsending(true);
        await sendEmail(values);
        setsuccess(true);
      } catch (error) {
        console.log(error);
        globalActions.setSnackbarMessage({
          message: t('contact.error'),
          severity: 'error'
        });
        setSubmitting(false);
        (0, _analytics.logEvent)(analytics, 'contact_error', {
          error_message: error.message
        });
      } finally {
        setsending(false);
      }
    }
  });
  _react.default.useEffect(() => {
    if (emailStatus === 'initial') {
      var _signInCheckResult$us;
      if ((signInCheckResult === null || signInCheckResult === void 0 ? void 0 : (_signInCheckResult$us = signInCheckResult.user) === null || _signInCheckResult$us === void 0 ? void 0 : _signInCheckResult$us.email) !== undefined) {
        var _signInCheckResult$us2;
        formik.setFieldValue('email', signInCheckResult === null || signInCheckResult === void 0 ? void 0 : (_signInCheckResult$us2 = signInCheckResult.user) === null || _signInCheckResult$us2 === void 0 ? void 0 : _signInCheckResult$us2.email);
        setemailStatus('set');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.email, formik.setFieldValue, signInCheckResult, emailStatus]);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    component: "form",
    onSubmit: formik.handleSubmit,
    sx: {
      width: '100%',
      p: 3,
      maxWidth: 800,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 1,
      gap: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      gap: 1,
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    style: {
      flexGrow: 1
    },
    name: "email",
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    value: formik.values.email,
    label: t('contact.email'),
    error: formik.touched.email && Boolean(formik.errors.email),
    helperText: formik.errors.email && formik.touched.email && formik.errors.email,
    inputProps: {
      maxLength: 50
    }
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    style: {
      flexGrow: 1
    },
    name: "nameAndCompany",
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    value: formik.values.nameAndCompany,
    label: t('contact.nameAndCompany'),
    error: Boolean(formik.errors.nameAndCompany),
    helperText: formik.errors.nameAndCompany && formik.errors.nameAndCompany,
    inputProps: {
      maxLength: 50
    }
  })), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    fullWidth: true,
    name: "message",
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    value: formik.values.message,
    label: t('contact.message'),
    error: formik.touched.message && Boolean(formik.errors.message),
    helperText: formik.errors.message && formik.touched.message && formik.errors.message,
    multiline: true,
    rows: 4,
    inputProps: {
      maxLength: 2000
    }
  }), /*#__PURE__*/_react.default.createElement(_LoadingButton.default, {
    size: "medium",
    loading: sending,
    variant: "contained",
    color: "primary",
    type: "submit",
    disabled: formik.isSubmitting,
    endIcon: /*#__PURE__*/_react.default.createElement(_Send.default, {
      fontSize: "small"
    })
  }, t('contact.send'))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "span",
    variant: "body2"
  }, t('contact.direct'), ' ', /*#__PURE__*/_react.default.createElement(_CopyToClipboard.default, {
    t: t,
    toBeCopied: "contact@labox-apps.com",
    child: /*#__PURE__*/_react.default.createElement(_Link.default, {
      sx: {
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 0.3
      }
    }, "contact@labox-apps.com", /*#__PURE__*/_react.default.createElement(_ContentCopy.default, {
      sx: {
        height: 18
      }
    }))
  })));
}